export default __webpack_public_path__ + "static/197-c21172a79626c2978e36339f2c508cff.jpg";